// ─────────────────────────────────────────────
// VFX SYSTEM (CSS-based animations)
// ─────────────────────────────────────────────
export const VFX_EFFECTS = [
  { id: "rainbow",    name: "Rainbow",    description: "Cycling rainbow colors" },
  { id: "glitch",     name: "Glitch",     description: "Digital glitch distortion" },
  { id: "rgbGlitch",  name: "RGB Glitch", description: "RGB channel glitch" },
  { id: "rgbShift",   name: "RGB Shift",  description: "RGB color separation" },
  { id: "shine",      name: "Shine",      description: "Animated shimmer" },
  { id: "spring",     name: "Spring",     description: "Elastic movement" },
  { id: "duotone",    name: "Duotone",    description: "Two-tone color overlay" },
  { id: "tritone",    name: "Tritone",    description: "Three-tone color overlay" },
  { id: "hueShift",   name: "Hue Shift",  description: "Rotating hue animation" },
  { id: "bounce",     name: "Bounce",     description: "Bouncy animation" },
  { id: "pixelate",   name: "Pixelate",   description: "Pixelated mosaic look" },
  { id: "halftone",   name: "Halftone",   description: "Newspaper print dots" },
  { id: "uvGradient", name: "UV Gradient", description: "UV gradient wash" },
  { id: "invert",     name: "Invert",     description: "Color inversion" },
  { id: "chromatic",  name: "Chromatic",  description: "Chromatic aberration" },
  { id: "vignette",   name: "Vignette",   description: "Dark vignette edges" },
];

export const VFX_CHANCE = 0.01; // 1% chance per roll

// IDs that were removed from the pool — filter them out of any stored items
export const REMOVED_VFX_IDS = ['blink', 'sinewave'];
